import styled from "styled-components";
import { DESKTOP } from "common/constants/breakpoints";

export default styled.nav`
  flex: 1;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px 12px 12px;
  background: transparent;

  @media screen and (min-width: ${DESKTOP}px) {
    padding: 40px;
  }
`;
